module.exports = __webpack_public_path__ + "img/epiImage.480b30de.svg";